"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _Instagram = _interopRequireDefault(require("@mui/icons-material/Instagram"));
var _Facebook = _interopRequireDefault(require("@mui/icons-material/Facebook"));
var _LinkedIn = _interopRequireDefault(require("@mui/icons-material/LinkedIn"));
var _Twitter = _interopRequireDefault(require("@mui/icons-material/Twitter"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _templateObject;
var StyledIconLink = (0, _styledComponents.default)(_Link.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: var(--bf-dark-grey) !important;\n"])));
var SocialMediaIconGroup = function SocialMediaIconGroup(props) {
  return _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center"
  }, props), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, _react.default.createElement(_Paragraph.default, {
    psmall: true
  }, "Follow us")), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 2,
    md: 1
  }, _react.default.createElement(StyledIconLink, {
    href: 'https://www.facebook.com/findyourbestfitcollege/'
  }, _react.default.createElement(_Facebook.default, null))), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 2,
    md: 1
  }, _react.default.createElement(StyledIconLink, {
    href: 'https://instagram.com/bestfit_app'
  }, _react.default.createElement(_Instagram.default, null))), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 2,
    md: 1
  }, _react.default.createElement(StyledIconLink, {
    href: 'https://www.linkedin.com/company/bestfit-app'
  }, _react.default.createElement(_LinkedIn.default, null))), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 2,
    md: 1
  }, _react.default.createElement(StyledIconLink, {
    href: 'https://twitter.com/bestfit_app'
  }, _react.default.createElement(_Twitter.default, null))));
};
var _default = SocialMediaIconGroup;
exports.default = _default;